export default __webpack_public_path__ + "static/media/bar-whitelabel.75a3312d.svg";